import { functions } from '@util/firebase';
import { httpsCallable } from 'firebase/functions';
import { ErrorObject, serializeError } from 'serialize-error';
export const logError = async (
  err: Error | string | unknown,
  id = generateRandomId(),
  componentStack?: string,
  message?: string
) => {
  try {
    console.error(err, id, componentStack, message);
    if (process.env.NODE_ENV === 'development') return;
    if (typeof err === 'string') err = new Error(err);
    const ctx = serializeError(err);
    if (componentStack) ctx.stack = componentStack;
    const body = JSON.stringify({
      ...serializeError(err),
      id,
      ...(message && { message }),
    });
    // Skip fetch during SSR/prerendering to avoid Next.js prerender errors
    if (typeof window === 'undefined') return;

    const host = process.env.NEXT_PUBLIC_IS_STAGING
      ? 'https://mxlocker.dev'
      : 'https://mxlocker.com';
    await fetch(`${host}/api/error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
    });
  } catch (e) {
    try {
      await recordException(e, {
        extra: { cause: 'logError' },
      });
      console.error('Error reporting error', e);
    } catch (e) {
      console.error('everything failed. rip.', e);
    }
  }
};

export async function recordException(
  e: Error | string | unknown,
  extra: {
    extra: { cause: string; [key: string]: any };
    user?: { id?: string; phone?: string; email?: string };
  }
) {
  console.error(e);
  try {
    if (typeof e === 'string') e = new Error(e);
    const err = serializeError(e);
    if (
      err.message?.includes('Location permission was denied') ||
      err.message?.includes('kCLErrorDomain error')
    )
      return;

    const extraInfo = extra;
    extraInfo.extra.version = process.env.NEXT_PUBLIC_VERSION ?? 'unknown';
    const url =
      typeof window !== 'undefined' ? window.location.href : 'unknown';
    extraInfo.extra.url = url;
    await httpsCallable<
      {
        err: ErrorObject;
        extraInfo: {
          extra: { cause: string; [key: string]: any };
          user?: { id?: string; phone?: string; email?: string };
        };
      },
      void
    >(
      functions,
      'v2_recordException'
    )({ err, extraInfo });
  } catch (e) {
    console.error('Failed to record exception', e);
  }
}

export const generateRandomId = () => {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 24; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};
